module.exports = __webpack_public_path__ + "img/02.49e89e33.jpg";